import React from 'react'

function StudyPlannerDatePopup({ message, setShowPop }) {
    console.log("message", message)
    return (
        <div className="ContainerSubmitedSucess" style={{ zIndex: "999" }}>
            <div className="SubContainerSubmitedSucess" >
                <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "25px" }}>
                    <img src="/images/alert.svg" alt="" />
                </div>
                <div className=" mt-3" style={{ textAlign: "center", fontSize: "30px", fontWeight: "600" }}>
                    <p>{message}</p>
                </div>
                {/* <div>Do you want to Start Assessment Now?</div> */}
                <div className="d-flex justify-content-around align-items-center mt-3 widthOfContainer">
                    <button
                        className="okayBtnsucess"
                        onClick={() => {
                            setShowPop(false)
                            // window.history.back()
                        }}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StudyPlannerDatePopup